import React from 'react';
import { string, number, shape } from 'prop-types';

import { format } from 'utils';
import { getLocalization } from '../utils';

const Results = ({ configName, numberFormat, results }) => {
    const pluralizedResults = `${format.number(
        results,
        numberFormat
    )} ${format.pluralize(results, {
        one: getLocalization(configName, 'results/one'),
        twoToFour: getLocalization(configName, 'results/twoToFour'),
        fiveOrMore: getLocalization(configName, 'results/fiveOrMore')
    })}`;

    return <span>{pluralizedResults}</span>;
};

Results.propTypes = {
    configName: string.isRequired,
    numberFormat: shape({
        precision: number,
        thousand: string,
        decimal: string
    }).isRequired,
    results: number.isRequired
};

export default Results;
